import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { StoreDetails as StoreDetailsUI, useConfig } from "@jti/ui";
const getStoreIdFromUrl = () => {
    const shopId = new URLSearchParams(window.location.search);
    return shopId.get("shopId");
};
const StoreDetails = ({ storeIcons }) => {
    const { locationServiceMapProvider } = useConfig();
    const [storeId, setStoreId] = useState(null);
    // hiding header store details for KOR as per market requirement
    const isHeaderAddressVisible = locationServiceMapProvider !== "naver";
    useEffect(() => {
        setStoreId(getStoreIdFromUrl());
    }, []);
    return (_jsx(_Fragment, { children: storeId && (_jsx(StoreDetailsUI, { storeIcons: storeIcons, storeId: storeId, isHeaderAddressVisible: isHeaderAddressVisible })) }));
};
export default StoreDetails;
//# sourceMappingURL=StoreDetails.js.map